export const environment = {
  production: true,
  demoData: false,
  url: 'https://devqa.reflact.info'
};
